<template>
  <admin-card title="Управление списком пользователей" :show-partners-block="false">
    <table class="table table-striped table-bordered admin-table">
      <thead>
      <tr v-if="isAdmin">
        <th colspan="4" class="admin-table__controls">
          <router-link :to="{ name: 'admin.user.add'}" class="btn btn-primary" active-class="active">
            Добавить
          </router-link>
        </th>
      </tr>
      <tr>
        <th>ID</th>
        <th>Имя</th>
        <th>Email</th>
        <th>Управление</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users">
        <td>{{ user.id }}</td>
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>
          <router-link :to="{ name: 'admin.user.view', params: {id: user.id} }"
                       class="btn btn-primary"
                       active-class="active">
            Детали
          </router-link>
          <router-link :to="{ name: 'admin.user.stats', params: {id: user.id} }"
                       class="btn btn-primary"
                       active-class="active">
            Активность
          </router-link>
          <router-link v-if="isAdmin" :to="{ name: 'admin.user.edit', params: {id: user.id} }"
                       class="btn btn-primary"
                       active-class="active">
            Редактировать
          </router-link>
          <button class="btn btn-warning" @click.prevent="removeUser(user)">Удалить</button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr v-if="isAdmin">
        <th colspan="4" class="admin-table__controls">
          <router-link :to="{ name: 'admin.user.add'}" class="btn btn-primary" active-class="active">
            Добавить
          </router-link>
        </th>
      </tr>
      </tfoot>
    </table>
  </admin-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  import AdminPage from '../admin-page';

  export default {
    metaInfo () {
      return { title: 'Пользователи' }
    },
    extends: AdminPage,
    computed: {
      ...mapGetters({
        isAdmin: 'auth/isAdmin',
        isCurator: 'auth/isCurator',
        users: 'users/users',
      }),
    },
    methods: {
      async removeUser (user) {
        this.$store.dispatch('users/remove', user.id);
      }
    },
    beforeMount () {
      this.$store.dispatch('users/fetchAll');
    }
  }
</script>
